module.exports = __webpack_public_path__ + "img/BETSSON.048e27c0.svg";